import { IntlShape } from "react-intl";
import { inputFilter, selectFilter, selectorFilter } from "../shared/crud/filter-widgets";
import { TableFilters } from "../shared/crud/list";
import { tableFilterMessages, typeMessage } from "./messages";
import { CustomExtraListItem, ExtraType, TranslationType } from "./types";

const booleanFilterFn = (data?: boolean, filter?: boolean) => filter?.toString() === String(data);

export default function getTableFilters(
  intl: IntlShape
): TableFilters<CustomExtraListItem, CustomExtraListItem> {
  return {
    active: {
      filterFn: booleanFilterFn,
      widget: selectFilter(intl, tableFilterMessages.active),
    },
    ticker: {
      filterFn: (data: string, filter: string) => data.toLowerCase().includes(filter.toLowerCase()),
      widget: inputFilter,
    },
    translationsList: {
      title: tableFilterMessages.name,
      filterFn: (data: TranslationType[], filter: TranslationType[]) => {
        const items = data.map(({ name }) => name.toLowerCase());
        return items.some(it => it.includes(((filter as unknown) as string).toLowerCase()));
      },
      widget: inputFilter,
    },
    type: {
      width: 350,
      filterFn: (data: ExtraType, filter: ExtraType) => data === filter,
      widget: selectorFilter(intl.formatMessage(tableFilterMessages.type), [
        {
          value: ExtraType.EXTRA_TYPE_ROOM,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_ROOM]),
        },
        {
          value: ExtraType.EXTRA_TYPE_ROOM_PER_DAY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_ROOM_PER_DAY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_ROOM_MANDATORY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_ROOM_MANDATORY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_ROOM_PER_DAY_MANDATORY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_ROOM_PER_DAY_MANDATORY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_ROOM_SPECIFIC_DATE,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_ROOM_SPECIFIC_DATE]),
        },
        {
          value: ExtraType.EXTRA_TYPE_PERSON,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_PERSON]),
        },
        {
          value: ExtraType.EXTRA_TYPE_PERSON_PER_DAY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_PERSON_PER_DAY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_PERSON_MANDATORY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_PERSON_MANDATORY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_PERSON_PER_DAY_MANDATORY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_PERSON_PER_DAY_MANDATORY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_PERSON_SPECIFIC_DATE,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_PERSON_SPECIFIC_DATE]),
        },
        {
          value: ExtraType.EXTRA_TYPE_UNIT,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_UNIT]),
        },
        {
          value: ExtraType.EXTRA_TYPE_UNIT_PER_DAY,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_UNIT_PER_DAY]),
        },
        {
          value: ExtraType.EXTRA_TYPE_UNIT_SPECIFIC_DATE,
          label: intl.formatMessage(typeMessage[ExtraType.EXTRA_TYPE_UNIT_SPECIFIC_DATE]),
        },
      ]),
    },
    codesList: {
      filterFn: (data: string[], filter: string[]) => {
        return data.some(it => {
          return it.toLowerCase().includes(((filter as unknown) as string).toLowerCase());
        });
      },
      widget: inputFilter,
    },
    isShared: {
      filterFn: booleanFilterFn,
      widget: selectFilter(intl, tableFilterMessages.isShared),
    },
  };
}
